import { useEffect, useId, useRef } from 'react'

export interface CampoProps {
  etiqueta: string
  valor: string
  alCambiar: (valor: string) => void
  tipo?: 'text' | 'email' | 'password'
  requerido?: boolean
  ayuda?: string
  error?: string
  marcador?: string
  autoFoco?: boolean
  /** Límite del servidor para este campo: la UI no deja escribir más de lo que la API acepta. */
  maxLongitud?: number
}

/** Campo de texto con etiqueta, ayuda y error asociados por `aria-describedby`. */
export function Campo(props: CampoProps) {
  const id = useId()
  const referencia = useRef<HTMLInputElement>(null)
  const descripciones = [props.ayuda ? `${id}-ayuda` : null, props.error ? `${id}-error` : null].filter(Boolean).join(' ')
  // Foco programático al montar (solo cuando quien usa el campo lo pide): el
  // usuario acaba de abrir un formulario y el primer campo es donde va a escribir.
  useEffect(() => {
    if (props.autoFoco) referencia.current?.focus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="grid gap-1">
      <label htmlFor={id} className="text-pequeno font-semibold text-texto">
        {props.etiqueta}
        {props.requerido ? <span aria-hidden="true"> *</span> : null}
      </label>
      <input
        ref={referencia}
        id={id}
        type={props.tipo ?? 'text'}
        value={props.valor}
        onChange={(e) => props.alCambiar(e.target.value)}
        required={props.requerido}
        placeholder={props.marcador}
        maxLength={props.maxLongitud}
        aria-invalid={props.error ? true : undefined}
        aria-describedby={descripciones || undefined}
        className="min-h-tactil w-full rounded-md border border-borde bg-superficie px-3 text-cuerpo text-texto placeholder:text-texto-secundario"
      />
      {props.ayuda ? <p id={`${id}-ayuda`} className="text-pequeno text-texto-secundario">{props.ayuda}</p> : null}
      {props.error ? <p id={`${id}-error`} role="alert" className="text-pequeno text-critico-texto">{props.error}</p> : null}
    </div>
  )
}
